import { useEffect } from 'react';

interface Options {
	listen?: boolean;
}

const useOnMessage = (events: Record<string, Function>, { listen = true }: Options = {}) => {
	function _parseMessage(msg: string) {
		try {
			const parsedMessage = JSON.parse(msg);

			if (parsedMessage.messageType) {
				parsedMessage.type = parsedMessage.messageType;
			}

			return parsedMessage;
		} catch {
			return {};
		}
	}

	function _handleCallback(callback: Function | undefined, ...args: any[]) {
		if (callback && callback instanceof Function) {
			callback(...args);
		}
	}

	function onMessage(e: MessageEvent<any>) {
		try {
			const { type, data } = _parseMessage(e.data);
			const callback = events[type];

			_handleCallback(callback, data);
		} catch (ex) {}
	}

	useEffect(() => {
		if (listen) {
			window.addEventListener('message', onMessage);
		}

		return () => window.removeEventListener('message', onMessage);
	}, [listen]);
};

export default useOnMessage;
